import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";
import { evidenceFiles } from "@/mocks/home";

export default function EvidenceSection() {
  return (
    <section id="evidence" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <Reveal>
          <SectionHeading
            index="05"
            eyebrow="Evidence Archive"
            title="实锤材料库"
            description="所有公开材料均经过脱敏与多方核验，标注编号、类型与来源，方便你自行比对与追溯。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {evidenceFiles.map((file, index) => (
            <Reveal key={file.code} delay={index * 50}>
              <article className="group flex h-full cursor-pointer flex-col justify-between rounded-lg border border-background-300 bg-background-50 p-6 transition-colors hover:border-primary-300">
                <div className="flex items-start justify-between gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className="ri-folder-shield-2-line text-lg"></i>
                  </span>
                  <span className="rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-600">
                    {file.type}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-base leading-7 text-foreground-950 transition-colors group-hover:text-primary-700">
                  {file.title}
                </h3>
                <dl className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <div className="flex flex-col gap-1">
                    <dt className="tracking-wide text-foreground-400">档案编号</dt>
                    <dd className="font-mono tracking-wide">{file.code}</dd>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    <dt className="tracking-wide text-foreground-400">来源 · {file.date}</dt>
                    <dd className="text-secondary-700">{file.source}</dd>
                  </div>
                </dl>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}